import { render, staticRenderFns } from "./DepositCancelModal.vue?vue&type=template&id=2733bc71&scoped=true"
import script from "./DepositCancelModal.vue?vue&type=script&lang=js"
export * from "./DepositCancelModal.vue?vue&type=script&lang=js"
import style0 from "./DepositCancelModal.vue?vue&type=style&index=0&id=2733bc71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733bc71",
  null
  
)

export default component.exports